<template>
  <div class="content">
    <div class="row">
      <div class="col-12">
        <card>
          <template slot="header">
            <div class="card-title">
				<div><img src="./../assets/img/logo.png" width="100px">
				<span style="font-size: 16px;vertical-align:middle;">惠州市科特测控工程有限公司</span>
				</div>
<!-- 				<div class="col-lg-6 col-md-12" style="text-align: center;vertical-align:middle;">
				<span style="font-size: 24px;text-align: center;">四年使用稳定率998‰</span>
				</div> -->
			</div>
			<div>
             <el-button type="primary" @click="pageParam.param.fileTypeId='';getFiles();" class="topButton">全部</el-button>
			 <el-button  class="topButton" type="primary" @click="pageParam.param.fileTypeId=typeitem.typeId;getFiles(typeitem.typeId);" v-for="typeitem in types">
				{{typeitem.typeName}}
			 </el-button>
			</div>
          </template>
          <div class="table-responsive text-left">
			  <el-table class="table" 
				  :data="files" width="100%"  
				  highlight-current-row
				  tooltip-effect="dark"
				  :stripe="true"
				  >
				  <el-table-column label="文件名">
					  <template slot-scope="scope">
						<a href="javascript:;" @click="handleBrowserCheck(getLink(scope.row))" style="color:#ba54f5;">
							{{scope.row.name}}
						</a>
					  </template>
				  </el-table-column>
				  <el-table-column prop="uploadTime" label="上传时间" v-if="!isMobile"></el-table-column>

				  <el-table-column prop="typeName" label="分类"></el-table-column>
				  <el-table-column prop="note" label="备注" v-if="!isMobile"></el-table-column>
			      </el-table>
          </div>
		  
		  <div class="block">
		    <el-pagination
		      @size-change="handleSizeChange"
		      @current-change="pageHandleCurrentChange"
		      :current-page="pageParam.currentPage"
		      :page-sizes="[10, 20, 50, 100]"
		      :page-size="10"
		      :layout="layout"
		      :total="pageParam.total">
		    </el-pagination>
		  </div>
		  
		  <div>
			  <el-tag class="yewu">
			    李生：18927386170
			  </el-tag>
			  <el-tag class="yewu">
			    姚生：15986975638
			  </el-tag>
			  <el-tag class="yewu">
			    张生：13798461021
			  </el-tag>
		  </div>
		  <div style="text-align: center;margin-top: 5px;margin-bottom: 5px;">
			  hzkete.com
		  </div>
        </card>
      </div>
    </div>
  </div>
</template>

<script>
import { Card } from "@/components/index";
import BaseTable from "@/components/BaseTable";
export default {
  components: {
    Card,
    BaseTable,
  },
  created() {
	this.get3DType();
	this.getFiles();
	this.checkMobile();
  },
  data() {
    return {
		files:[],
		types:[],
		pageParam:{
			pageNum:1,
			pageSize:10,
			total:0,
			currentPage:1,
			pages:1,
			param:{
				fileTypeId:""
			}
		},
		layout:"total,sizes,prev,pager,next,jumper",
		isMobile:false
    };
  },
  methods:{
	  checkMobile() {
	        const isMobile = /iPhone|iPad|iPod|Android/i.test(window.navigator.userAgent);
	        this.isMobile = isMobile;
			if(isMobile){
				this.layout="sizes,prev,pager,next";
			}
	  },
		isWeChatBrowser() {
			const ua = navigator.userAgent.toLowerCase();
			return ua.includes('micromessenger');
		},
		handleBrowserCheck(url) {
			if (this.isWeChatBrowser()) {
			alert('由于微信的限制不能下载文件，请点击右上角选择在浏览器中打开页面以下载文件。');
			//return false;
			}else{
				window.open(url);
			}
		},
	  getFiles(){
	  	this.$axios.post(this.$serverUrl+"/file/publicList",this.pageParam).then(
	  	response => {
	  	  if(response.status==200){
	         this.files=response.data.list;
	  		 this.pageParam.total=response.data.total;
	  		 this.pageParam.pages=response.data.pages;
	  	  }else{
	  		Message(
	  		{
	  		 type: "error",
	  		 message: response.data.msg,
	  		 offset:window.screen.height/2-100
	  		});
	  	  }
	  	}
	  	).catch(
	  	)
	  },
	  getLink(val){
		console.log(val);
	  	return this.$serverUrl+"/file/download?fileId="+val.fileId;
	  },
	  handleSizeChange(val){
	  	this.pageParam.pageSize=val;
	  	this.getFiles();
	  },
	  pageHandleCurrentChange(val){
	  	this.pageParam.pageNum=val;
	  	this.getFiles();
	  },
	  get3DType(){
	  	this.$axios.get(this.$serverUrl+"/file/drawingType").then(
	  		response => {			
	  		  if(response.data.state==200){
	  			  this.types=[];
	  			  this.types=response.data.data;
	  		  }else{
	  			Message(
	  			{
	  			 type: "error",
	  			 message: response.data.msg,
	  			 offset:window.screen.height/2-100
	  			});
	  		  }
	  		}
	  	).catch(	
	  		error=>{
	  			if(error.response.data.state===500){	
	  			Message(
	  			{
	  			 type: "error",
	  			 message: "系统出错了。",
	  			 offset:window.screen.height/2-100
	  			});
	  			}
	  	})
	  },
  }
};
</script>
<style>
	.topButton{
		margin-bottom: 5px;
	}
	.yewu{
		margin-right: 5px;
		margin-bottom: 5px;
		margin-top: 5px;
	}
</style>